module.exports = __webpack_public_path__ + "img/baner-logo.b83503ba.webp";